var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "modal-card" }, [
    _c("div", { staticClass: "modal-card-head centered-items" }, [
      _vm._v(
        " " + _vm._s(_vm.$t("pages.pickup_management.closures.title")) + " "
      ),
    ]),
    _c("div", { staticClass: "modal-card-body" }, [
      _vm.creatingClosure
        ? _c(
            "div",
            {
              staticClass: "closureForm",
              attrs: { id: "calendar-step-cd-screen" },
            },
            [
              _c("ValidationObserver", {
                ref: "observer",
                attrs: { tag: "form" },
                on: {
                  submit: function ($event) {
                    $event.preventDefault()
                    return _vm.submit.apply(null, arguments)
                  },
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function ({ valid }) {
                        return [
                          _c(
                            "div",
                            { attrs: { id: "form" } },
                            [
                              _c("h2", { staticClass: "subtitle" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t(
                                        "pages.pickup_management.closures.add_closing_date"
                                      )
                                    ) +
                                    " : "
                                ),
                              ]),
                              _c(
                                "b-field",
                                { attrs: { label: _vm.$t("global.enduser") } },
                                [
                                  _c("multiselect", {
                                    attrs: {
                                      options: _vm.endusers,
                                      multiple: false,
                                      "close-on-select": true,
                                      "custom-label": (n) => {
                                        return (
                                          n.enduserCode + " - " + n.enduserName
                                        )
                                      },
                                      "track-by": "name",
                                    },
                                    model: {
                                      value: _vm.selectedEnduser,
                                      callback: function ($$v) {
                                        _vm.selectedEnduser = $$v
                                      },
                                      expression: "selectedEnduser",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "b-field",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "pages.pickup_management.closures.start_date"
                                    ),
                                  },
                                },
                                [
                                  _c("ValidationProvider", {
                                    attrs: {
                                      rules: "required",
                                      name: "start date",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function ({ errors }) {
                                            return [
                                              _c("b-datepicker", {
                                                attrs: {
                                                  name: "start date",
                                                  icon: "calendar-alt",
                                                  placeholder: _vm.$t(
                                                    "global.click_to_select"
                                                  ),
                                                  "date-formatter": (date) =>
                                                    _vm
                                                      .$dayjs(date)
                                                      .format("DD/MM/YYYY"),
                                                  editable: "",
                                                },
                                                model: {
                                                  value:
                                                    _vm.newClosure.startDate,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.newClosure,
                                                      "startDate",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "newClosure.startDate",
                                                },
                                              }),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "has-text-danger",
                                                },
                                                [_vm._v(_vm._s(errors[0]))]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "b-field",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "pages.pickup_management.closures.end_date"
                                    ),
                                  },
                                },
                                [
                                  _c("ValidationProvider", {
                                    attrs: {
                                      rules: "required",
                                      name: "end date",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function ({ errors }) {
                                            return [
                                              _c("b-datepicker", {
                                                attrs: {
                                                  name: "end date",
                                                  icon: "calendar-alt",
                                                  placeholder:
                                                    "Click to select...",
                                                  "date-formatter": (date) =>
                                                    _vm
                                                      .$dayjs(date)
                                                      .format("DD/MM/YYYY"),
                                                  editable: "",
                                                },
                                                model: {
                                                  value: _vm.newClosure.endDate,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.newClosure,
                                                      "endDate",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "newClosure.endDate",
                                                },
                                              }),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "has-text-danger",
                                                },
                                                [_vm._v(_vm._s(errors[0]))]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "b-field",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "pages.pickup_management.closures.comments"
                                    ),
                                  },
                                },
                                [
                                  _c("ValidationProvider", [
                                    _c("textarea", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.newClosure.comment,
                                          expression: "newClosure.comment",
                                        },
                                      ],
                                      staticClass: "input",
                                      domProps: {
                                        value: _vm.newClosure.comment,
                                      },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.$set(
                                            _vm.newClosure,
                                            "comment",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                  ]),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "centered-items buttons" },
                                [
                                  _c(
                                    "b-button",
                                    {
                                      staticClass: "button",
                                      on: {
                                        click: () =>
                                          (_vm.creatingClosure = false),
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.$t("global.cancel")) +
                                          " "
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "button",
                                    {
                                      staticClass: "is-primary button",
                                      attrs: { type: "submit" },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.$t("global.submit")) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  4115981087
                ),
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.computedGridData
        ? _c(
            "div",
            [
              _c(
                "div",
                { staticClass: "buttons" },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "is-warning is-small",
                      staticStyle: { "margin-bottom": "30px" },
                      attrs: { "icon-left": "arrow-left" },
                      on: { click: _vm.close },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("global.back")) + " ")]
                  ),
                  _c(
                    "b-button",
                    {
                      staticClass: "is-info is-small",
                      staticStyle: { "margin-bottom": "30px" },
                      attrs: { "icon-left": "plus" },
                      on: {
                        click: () => {
                          _vm.creatingClosure = true
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("global.add")) + " ")]
                  ),
                  _c(
                    "b-button",
                    {
                      staticClass: "is-small",
                      class: _vm.hidingPastDates ? "is-primary" : "is-danger",
                      staticStyle: { "margin-bottom": "30px" },
                      attrs: { "icon-left": "low-vision" },
                      on: { click: _vm.hidePastDates },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.hidingPastDates
                              ? _vm.$t(
                                  "pages.pickup_management.closures.display_past_dates"
                                )
                              : _vm.$t(
                                  "pages.pickup_management.closures.hide_past_dates"
                                )
                          ) +
                          " "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c("b-loading", {
                attrs: { active: _vm.loading, "is-full-page": "" },
                on: {
                  "update:active": function ($event) {
                    _vm.loading = $event
                  },
                },
              }),
              _c("ag-grid-vue", {
                staticClass: "ag-theme-balham",
                staticStyle: { width: "100%", height: "1000px" },
                attrs: {
                  "row-data": _vm.computedGridData,
                  "grid-options": _vm.gridOptions,
                  pagination: true,
                  "pagination-auto-page-size": true,
                  "multi-sort-key": "ctrl",
                  modules: _vm.modules,
                  "row-selection": "multiple",
                  "group-hide-open-parents": true,
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }